import styled from 'styled-components';
import { ThemeColours } from '../../../../../../../styles/ThemeColours';
import { HeImgix } from '../../../../../../images/HeImgix';

export const RectagularImage = styled(HeImgix)`
  border: 1px solid ${ThemeColours.mono200};
  border-radius: 4px;
  height: 40px;
  width: 40px;
`;
